













import { Component, Vue } from 'vue-property-decorator';
import VideoPlayer from '@/components/VideoPlayer.vue';
import LocaleService from '@/services/LocaleService';
import GameLogic from "../services/GameLogic";
import Animations from "../services/Animations";

@Component({
    components: {
        VideoPlayer,
    },
    computed: {
        fullVideoURL():string {
            return [this.$store.state.locale, "/video/introduction.mp4"].join("");
        },
        skipLabel():string {
            return LocaleService.getValue(this.$store.state, "algemeen.introductie.skipbutton.title");
        }
    },
    methods: {
        handleSkip():void {
            let el:HTMLElement = <HTMLElement> this.$refs.fader;
            Animations.fadeIn(el).then(() => this.$router.push('/welcome'));
        }
    },
    created() {
        //console.log("resetting game from intro page");
        this.$store.commit('resetGame');
    }
})
export default class Intro extends Vue {}
